<template>
    <div class="page bg-blue relative desktop-footer">
        <div class="bg-head-coin"></div>
        <div class="page-content sm:px-8">
            <TopBarProfile :modalController="modalController"/>
            <MenuDesktop activeMenu=""></MenuDesktop>
            <div class="sm:bg-white sm:px-5 sm:pt-2 mt-4 rounded-25">
                <div class="bg-tc-gray-5 sm:bg-opacity-0 sm:p-0 mt-7">
                    <div class="p-4 pt-12 sm:flex justify-center">
                        <div class="block sm:hidden">
                            <UserInfoMobile :userData="profileInfo" @clickTransfer="onClickTransferPoint()"/>
                        </div>
                        <div class="hidden sm:block">
                            <UserInfoDesktop :userData="profileInfo" @clickTransfer="onClickTransferPoint()"/>
                        </div>
                    </div>
                    <div class="bg-white">
                        <InsuranceInfo
                            :modalController="modalController"
                            :profileInfo="profileInfo"
                            @updatePoint="updatePoint" />
                        <div class="sm:p-4">
                            <div class="line w-full bg-tc-gray-4 mt-6 mb-4"></div>
                        </div>
                    </div>
                    <MenuTermandcondition :controller="modalController"/>
                    <div class="pt-32">
                        <div class="w-full fixed left-0 bottom-0 bg-tc-gray-5 px-2 pb-4 z-10">
                            <MenuMobile activeMenu="profile" :userData="userData"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
// import MobilePage from "@/module/Profile/component/MainMenuMobile.vue";
import TopBarProfile from '@/module/Profile/component/Topbar.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import MenuMobile from '@/components/Layout/MenuMobile/MenuMobile.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import UserInfoMobile from '@/module/Profile/component/UserInfoMobile.vue';
import UserInfoDesktop from '@/module/Profile/component/UserInfoDesktop.vue';
import InsuranceInfo from '@/module/Profile/component/InsuranceInfo.vue';
import MenuTermandcondition from '@/module/Profile/component/MenuTermAndCondition.vue';


//service
import BzbsRegister from "@/module/Register/service/BzbsRegister";
import BzbsProfile from "@/core/Account/service/BzbsProfile"
//model
import { UserInfoModel } from '@/core/Account/model/UserInfoModel'
import Account from '@/helper/AccountHelper.js';
import ConfigManager from '@/config/ConfigManager.js';
//mixin
import ModalMixin from '@/mixin/ModalMixin';
import AuthStatusMixin from "@/mixin/AuthStatusMixin";
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    name: 'Profileinfo',
    mixins: [ModalMixin,AuthStatusMixin,LocaleMixin],
    components:{
        BottomBar,
        UserInfoMobile,
        InsuranceInfo,
        MenuTermandcondition,
        MenuDesktop,
        MenuMobile,
        TopBarProfile,
        UserInfoDesktop,
    },
    data: function(){
        return{
            userData: new UserInfoModel(''),
            profileImageUrl: '',
            profileInfo: {
                firstName: '',
                lastName: '',
                idcard: '',
                contact_number: '',
                email: '',
                profileImageUrl: '',
                point: 0
            },
            insuranceList: []
        }
    },
    created: function(){

    },
    methods:{
        // AuthStatusMixin
        onAccountInit: async function() {
            if (this.isLogin) {
                let token = Account.getToken();
                let currentTime = new Date().getTime();
                let cacheUser = Account.getCacheUser();
                if(cacheUser.channel == 'line' && cacheUser.line){
                    this.profileImageUrl = cacheUser.line.pictureUrl + `?time=${currentTime}`
                } else{
                    this.profileImageUrl = ConfigManager.getApiUrl() +
                    `/profile/${this.profile.userId}/picture?type=large&token=${token}&time=${currentTime}`;
                }
                this.modalController.loadingModal.show();
                //innit profile data
                this.profileInfo.lastName = this.profile ? this.profile.lastName : '';
                this.profileInfo.firstName = this.profile ? this.profile.firstName : '';
                this.profileInfo.idcard = this.profile ? this.profile.nationalIdCard : '';
                this.profileInfo.contact_number = this.profile ? this.profile.contactNumber : '';
                this.profileInfo.email = this.profile ? this.profile.email : '';
                this.profileInfo.profileImageUrl = this.profileImageUrl;
                this.profileInfo.point = this.profile.updated_points ? this.profile.updated_points.points : 0
                // await this.getUserMemberProfile();
                await this.callApiGetPolicy();
                this.modalController.loadingModal.hide();
            }
        },
        //#region ยกเลิกการเรียกเส้น /user/member
        getUserMemberProfile: function(){
             return new Promise((resolve) => {
                let data = {
                    IDCard: this.profileInfo.idcard,
                    ContactNumber: this.profileInfo.contact_number
                }
                BzbsProfile.getUserMember(data).subscribe({
                    next: (res) => {
                        if(res.data.length){
                            this.userData = new UserInfoModel(res.data[0]);
                            this.userData.profileImageUrl = this.profileImageUrl;
                        }
                        resolve(res)
                    },
                    error: (err) => {
                        console.log(err)
                        this.modalController.alertModal
                            .setTitle(this.lbl.profile.error)
                            .setMsg(err.message)
                            .show()
                        resolve(false)
                    }
                });
             })
        },
        //#endregion
        callApiGetPolicy: function () {
            return new Promise((resolve)=>{
                let params = this.profileInfo
                BzbsRegister.getPolicy(params)
                    .subscribe({
                        next: (res) => {
                            // this.setCahceRegister();
                            var pointType = 'point';
                            if (res.data.PolicyInsurances.length > 0) {
                                pointType = 'notpoint'
                            }
                            console.log(pointType)
                            console.log(res.data.PolicyInsurances)
                            this.insuranceList = res.data.PolicyInsurances.map(data => ({
                                img: data ? data.ImageUrl : '',
                                title: '',
                                name: '',
                                number: '',
                                startDate: '',
                                endDate: '',
                                condition: '',
                                carId: '',
                                isWarning: false,
                                buttonText: '',
                            }))
                            resolve(res);
                        },
                        error: (err) => {
                            console.log(err);
                            // this.handleError(err);
                            this.modalController.loadingModal.hide();
                            resolve(null);
                        }
                });
            });
        },
        onClickTransferPoint: function(){
            //console.log('onClickTransferPoint', this.userPoint)
            if(!this.userPoint){
                this.modalController.alertModal.setMsg(this.lbl.profile.point_not_enough).show();
            }
            else if(!Account.getUserLevel()){
                this.modalController.alertModal.setMsg(this.lbl.profile.not_customer).show();
            }else{
                this.$router.push('/transfer/point')
            }
        },
        updatePoint: function(point){ 
            //console.log('updatePoint 1', point);
            this.profileInfo.point = point;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
.logo-mobile-size {
    width: 80px; //53px
}
.line{
    height: 0.5px;
    transform: rotate(-180deg);
}
</style>
